<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="border-none py-0 mb-0 no-margin px-1">
      <!-- <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="text-primary mr-1"></i>
        {{ item.name }}
        <span class="text-warning"
          >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
        >
      </b-card-header> -->
      <div class="availtable datatable text-left">
        <b-card-body class="py-0 px-0">
          <b-tabs class="gridtabs" v-model="action_tab">

            <b-tab :active="true">
              <template #title>
                <i :class="options.icon" class="text-primary mr-1"></i>
                {{ item.name }}
                <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
              </template>
              <b-row class="mt-2">
                <b-col cols="12" sm="6">
                  <b-form-group label="Name" label-for="name" label-cols="12">
                    <b-input-group>
                      <b-form-input type="text" v-model="item.name" placeholder="Enter name" size="sm"
                        :disabled="readonly"></b-form-input>
                      <b-input-group-append>
                        <b-button size="sm" variant="outline-secondary" @click="item.name = ''" :disabled="readonly">
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label="Folder" label-for="category" label-cols="12">
                    <b-input-group>
                      <b-form-input type="text" v-model="item.category" placeholder="Enter folder" size="sm"
                        :disabled="readonly"></b-form-input>
                      <b-input-group-append>
                        <b-button size="sm" variant="outline-secondary" @click="item.category = ''" :disabled="readonly">
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-row>
                    <b-col>
                      <b-form-group label="Archive?" label-for="archive" label-cols="12">
                        <b-form-radio-group id="archive" v-model="item.archive" :options="[
    { text: 'Yes', value: true },
    { text: 'No', value: false },
  ]" buttons button-variant="outline-success" size="sm" name="radio-btn-outline"></b-form-radio-group>
                      </b-form-group></b-col>
                    <b-col>
                      <b-form-group label="New?" label-for="new" label-cols="12">
                        <b-form-radio-group id="new" v-model="item.new" :options="[
    { text: 'Yes', value: true },
    { text: 'No', value: false },
  ]" buttons button-variant="outline-success" size="sm" name="radio-btn-outline"></b-form-radio-group>
                      </b-form-group></b-col>
                  </b-row>
                </b-col>

                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label-cols="12" label="Event" label-size="sm">
                    <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                      v-model="item.eventcode" :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested :multiple="true">
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                    <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..."
                      v-model="item.slac" :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested :disabled="user.rolename == 'client'" :multiple="true">
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6">
                  <b-form-group label="To" label-for="to" label-cols="12">
                    <b-input-group>
                      <b-form-input type="text" v-model="item.to" placeholder="Enter to" size="sm"
                        :disabled="readonly"></b-form-input>
                      <b-input-group-append>
                        <b-button size="sm" variant="outline-secondary" @click="item.to = ''" :disabled="readonly">
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="6" md="6" xl="6">
                  <b-form-group label="Click x to remove or browse for document upload..." label-size="sm">
                    <b-input-group>
                      <!-- :disabled="item.data ? false : true" -->
                      <b-input-group-prepend>
                        <b-button size="sm" title="delete" variant="outline-danger" @click="fileUpload_clear">
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-prepend>
                      <b-form-file class="ml-1 z-0" id="file-small" size="sm" ref="file-input" :multiple="false" no-drop
                        @change="fileUpload_selected" :placeholder="fileUpload ? fileUpload.name : 'No file chosen'
    " :disabled="fileUpload ? true : false"></b-form-file>
                      <b-input-group-append>
                        <b-button class="ml-1" size="sm" title="view file" variant="outline-primary"
                          @click="fileUpload_view" :disabled="!fileUpload">
                          <i class="fa fa-download"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <!-- <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Date" label-for="date" label-cols="12">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.updated_df"
                    placeholder="Enter date"
                    size="sm"
                    :disabled="true"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.updated_df = ''"
                      :disabled="true"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col> -->
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-row>
                    <b-col>
                      <b-form-group label="Type" label-for="type" label-cols="12">
                        <treeselect instanceId="type" type="number" v-model="item.type" :clearable="true"
                          :options="type_options" :disabled="true"></treeselect>
                      </b-form-group></b-col>
                    <b-col>
                      <b-form-group label="Size" label-for="size" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.size" placeholder="Enter size" size="sm"
                            :disabled="true"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.size = ''" :disabled="true">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group> </b-form-group></b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab>
              <template #title>
                <i class="fa fa-comments-o text-primary mr-1"></i>
                Notes
              </template>
              <b-row>
                <b-col cols="12">
                  <wysiwyg :disabled="true" v-model="item.notes" :options="{
    hideModules: {
      code: true,
    },
  }" />
                  <!-- hideModules: {
                      bold: true,
                      italic: true,
                      underline: true,
                      justifyLeft: true,
                      justifyCenter: true,
                      justifyRight: true,
                      headings: true,
                      link: true,
                      code: true,
                      orderedList: true,
                      unorderedList: true,
                      image: true,
                      table: true,
                      removeFormat: true,
                      separator: false,
                    }, -->
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-card-body>
      </div>

      <b-card-footer class="mx-1 nopadding mt-2">
        <b-row no-gutters>
          <b-col cols="auto" class="text-left">
            <b-button squared size="sm" variant="primary" @click="saveit">
              <i class="fa fa-check"></i>
              Save It
            </b-button>          
          </b-col>
          <b-col class="text-left ml-2 pt-1">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>

          <b-col class="text-right" cols="auto">
            <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>           
          </b-col>
        </b-row>
      </b-card-footer>

      <!-- <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
            <b-button squared size="sm" variant="primary" @click="saveit">
              <i class="fa fa-check"></i>
              Save It
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer> -->
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "DocumentEdit",
  data() {
    return {
      busy: false,
      readonly: false,
      options_categories: [],
      type_options: [
        { id: 0, label: "File" },
        { id: 1, label: "File folder" },
      ],
      item: {
        name: null,
        category: [],
        slac: [],
        eventcode: [],
        notes: null,
        type: null,
        updated_df: null,
        size: null,
        archive: false,
        new: true,
        to: null,
      },
      options: {
        title: "Documents",
        icon: "fa fa-sitemap",
      },
    };
  },
  watch: {
    fileUpload: {
      immediate: true,
      deep: true,
      async handler(newVal, oldVal) {
        this.item.type = 0;
        if (newVal) {
          console.log("watch:fileUpload", newVal);
          this.item.name = newVal.name;
          this.item.size = newVal.size;
        } else {
          this.item.name = null;
          this.item.size = 0;
        }
      },
    },
    "item.name": {
      async handler(newVal, oldVal) {
        if (this.fileUpload) {
          this.fileUpload.name = newVal;
        }
      },
    },
  },
  async mounted() {
    let data = await this.$helpers.getsystemsetting("documents_categories");
    if (data) {
      this.options_categories = JSON.parse(data);
    }
    if (this.user.rolename == "client") {
      this.item.slac = this.user.slac.split(",");
    }
  },
  methods: {
    async load() {
      let variables = {
        id: this.idselected,
        dateformat: "YYYY-MM-DD HH:MM",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query documents($id: String, $dateformat: String) {
              documents(id: $id, dateformat: $dateformat) {
                id
                name
                archive
                new
                category
                eventcode
                slac
                data
                notes
                type
                size
                to
                updated_df
              }
            }
          `,
          variables,
        });

        if (response.data.documents.length > 0) {
          this.item = response.data.documents[0];

          this.item.slac = this.item.slac ? this.item.slac.split(",") : [];
          this.item.eventcode = this.item.eventcode
            ? this.item.eventcode.split(",")
            : [];
          // this.item.category = this.item.category
          //   ? this.item.category.split(",")
          //   : [];

          if (this.item.data) {
            this.fileUpload = JSON.parse(this.item.data);
          }
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      this.busy = true;

      this.item.slac =
        this.item.slac.length > 0 ? this.item.slac.join(",") : null;
      this.item.eventcode =
        this.item.eventcode.length > 0 ? this.item.eventcode.join(",") : null;
      this.item.category =
        this.item.category.length > 0 ? this.item.category.join(",") : null;

      let variables = {
        rows: [this.cleanit(this.item)],
        dateformat: "DD/MM/YY HH:MM",
      };
      if (this.fileUpload) {
        variables.rows[0].data = JSON.stringify(this.fileUpload);
      } else {
        variables.rows[0].data = "";
      }
      console.log("variables", variables);

      delete variables.rows[0].updated_df;

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation documents_save(
              $rows: [Document_input]
              $dateformat: String
            ) {
              documents_save(rows: $rows, dateformat: $dateformat) {
                id
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }
      this.$store.dispatch("documents");
      this.busy = false;
    },
  },
};
</script>

<style></style>